module.exports = __webpack_public_path__ + "static/img_pay_complete@2x-87cacb7ea6c0113fec6c962589256e88.png";